import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { useIntl } from '@divvy-web/i18n'
import BasicButton, {
  BASIC_BUTTON_COLOR_DEFAULT,
  BASIC_BUTTON_TYPE_FLAT_TRANSPARENT,
} from '@divvy-web/skylab.basicbutton'

import { URL } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const HelpButton = () => {
  const [getClassName] = useNameFormatter('HelpButton')
  const { formatMessage } = useIntl()
  const { track } = useWebTracking()

  const onHelpClick = () => {
    window.open(URL.BILL_HELP_CENTER_LINK, '_blank', 'noopener, noreferrer')
  }

  return (
    <div className={getClassName('')}>
      <BasicButton
        color={BASIC_BUTTON_COLOR_DEFAULT}
        icon='help'
        name={formatMessage({ defaultMessage: 'open bill help site', id: 'sputnik.HelpButton__CLAjD/' })}
        type={BASIC_BUTTON_TYPE_FLAT_TRANSPARENT}
        onClick={() => {
          track('se_signup__application_dashboard_home_help_link__fired')
          onHelpClick()
        }}
      />
    </div>
  )
}

export default HelpButton
